import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { LoaderService } from "./components/loader/loader.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MDBBootstrapModulesPro, ToastModule } from "ng-uikit-pro-standard";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./modules/shared/shared.module";
import { ApplicationConfig } from "./config/application.config";
import { ApiRoutes } from "./config/api-routes";
import { LoggedInGuard } from "./guards/logged-in.guard";
import { NgSelectModule } from "@ng-select/ng-select";
import { AngularSvgIconModule } from "angular-svg-icon";
import { UserNavbarComponent } from "./modules/shared/components/user-navbar/user-navbar.component";
import { LoginComponent } from "./modules/login/login.component";
import { ForgotPasswordComponent } from "./modules/forgot-password/forgot-password.component";
import { SetPasswordComponent } from "./modules/set-password/set-password.component";
import { ResetPasswordComponent } from "./modules/reset-password/reset-password.component";
import { NotLoggedInGuard } from "./guards/not-logged-in.guard";
import { GlobalErrorHandler } from "./config/global-error-handler";
import {
  ChappsCommonAngularLibraryModule,
  ChappsListModule
} from "@npm.chapps.com/chapps.common.angular.library";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { Localization } from "./modules/shared/enums/localization";
import { ImageCropperModule } from "ngx-image-cropper";
import { ILocalization } from "@npm.chapps.com/chapps.common.angular.library/lib/interface/ILocalization";
import { JobService } from "./modules/shared/service/job.service";
import { JobListItemComponent } from "./modules/shared/components/job-list-item/job-list-item.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from "@angular/material/button";
import { JobComponent } from "./modules/jobs/details/job.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { InterventionTeamService } from "./modules/shared/service/interventionTeamService";
import { DeclineModalComponent } from "./modules/shared/components/decline-modal/decline-modal.component";
import { environment } from "../environments/environment";
import { ExecuteModalComponent } from "./modules/shared/components/execute-modal/execute-modal.component";
import { BuildingsComponent } from "./modules/buildings/buildings.component";
import { BuildingComponent } from "./modules/buildings/details/building.component";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatBadgeModule } from "@angular/material/badge";
import { AcceptModalComponent } from "./modules/jobs/accept-modal/accept-modal.component";
import { ContactService } from "./modules/shared/service/contact.service";
import { OfflineGuard } from './guards/offline.guard';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatCardModule} from '@angular/material/card';
import { MatNativeDateModule } from "@angular/material/core";
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { IssueDialogComponent } from './modules/issues/issue-dialog/issue-dialog.component';
import {MatInputModule} from '@angular/material/input';
import { IssueService } from "./modules/shared/service/issue-service";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    environment.apiUrl + "backend/translations/",
    ".json"
  );
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    UserNavbarComponent,
    LoginComponent,
    ForgotPasswordComponent,
    SetPasswordComponent,
    ResetPasswordComponent,
    JobListItemComponent,
    JobComponent,
    AcceptModalComponent,
    DeclineModalComponent,
    ExecuteModalComponent,
    BuildingComponent,
    BuildingsComponent,
    IssueDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    SharedModule.forRoot(),
    NgSelectModule,
    AngularSvgIconModule,
    ChappsListModule,
    ChappsCommonAngularLibraryModule.forRoot(
      Localization as ILocalization,
      ApplicationConfig.PRIMARY_COLOR,
      ApplicationConfig.SECONDARY_COLOR
    ),
    ImageCropperModule,
    MatExpansionModule,
    MatDividerModule,
    MatButtonModule,
    MatToolbarModule,
    ServiceWorkerModule.register("/ngsw-worker.js", {
      enabled: environment.production
    }),
    MatListModule,
    MatTabsModule,
    MatBadgeModule,
    MatDatepickerModule,
    MatCardModule,
    MatNativeDateModule,
    MatSelectModule,
    MatFormFieldModule,
    HammerModule,
    MatInputModule,
  ],
  providers: [
    InterventionTeamService,
    JobService,
    IssueService,
    LoaderService,
    ApplicationConfig,
    ApiRoutes,
    LoggedInGuard,
    ContactService,
    NotLoggedInGuard,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    OfflineGuard
  ],
  bootstrap: [AppComponent],
  entryComponents: [JobListItemComponent]
})
export class AppModule {}
